/*
 *
 * Login actions
 *
 */

import {
  FLUSH_STATE,
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
} from './constants';


// Clearing the state
export function flushState() {
  return {
    type: FLUSH_STATE,
  };
}

/**
 * Load the user, this action starts the request saga
 *
 * @return {object} An action object with a type of LOAD_VARIABLES
 */
export function loginUser(loginValues, isApp) {
  return {
    type: LOGIN_USER,
    loginValues,
    isApp
  };
}

/**
 * Dispatched when the loadVariables are loaded by the request saga
 *
 * @param  {array} currentUser true for variables
 *
 * @return {object}      An action object with a type of LOAD_VARIABLES_SUCCESS passing the variables
 */
export function loginUserSuccess(currentUser, authenticated) {
  return {
    type: LOGIN_USER_SUCCESS,
    currentUser,
    authenticated,
  };
}


/**
 * Dispatched when loading the loadVariables fails
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_VARIABLES_ERROR passing the error
 */
export function loginUserError(error) {
  return {
    type: LOGIN_USER_ERROR,
    error,
  };
}
